import { LoadStatus } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const loadRevertStatusAtom = createMutationAtomFactory(
  'trade.loadRevertStatus',
  (params: { id: string; targetStatus: LoadStatus }) => ({
    tradeLoadRevertStatus: {
      __args: {
        id: params.id,
        targetStatus: params.targetStatus,
      },
      id: true,
      status: true,
      expectedShipDate: true,
      description: true,
      salesOrderId: true,
      bookingId: true,
      facilityId: true,
      shippingCarrierName: true,
      scac: true,
      freightForwarder: true,
      truckFreight: true,
      deliveryNumber: true,
      releaseNumber: true,
      driverName: true,
      truckNumber: true,
      trailerNumber: true,
      containerNumber: true,
      sealNumber: true,
      containerTypeId: true,
      containerType: {
        id: true,
        name: true,
      },
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
